@if (showPrintButton) {
    <div class="edit-bet-history-print-toolbar">
        <div class="my-bets-toolbar_button" (click)="onPrintBtnClicked($event)">
            <span>{{ printButtonTitle }}</span> <vn-icon name="theme-print" size="18" />
        </div>
    </div>
}

<div class="popup-body cards mybetscontent">
    <div id="betslips-list-wrapper">
        @for (betslip of betslips; track betslip.betslipId; let first = $first) {
            <div class="my-bets-list-betslip-container" [id]="betslip.betslipId">
                <ms-my-bets-edit-bet-history-betslip [betslip]="betslip" [myBetsListContext]="myBetsListContext" [isFirst]="first" />
            </div>
        }
    </div>
</div>
